import { type FC } from 'react';

// This is defined in vite.config.ts
declare const BUILD_TIMESTAMP: number;

const BuildInfo: FC = () => {
  const buildDate = new Date(BUILD_TIMESTAMP);
  const formattedDate = `${buildDate.toLocaleDateString()} ${buildDate.toLocaleTimeString()}`;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '5px',
        right: '5px',
        background: 'rgba(0, 0, 0, 0.5)',
        color: 'white',
        padding: '2px 5px',
        fontSize: '10px',
        borderRadius: '3px',
        zIndex: 9999,
        fontFamily: 'monospace',
        userSelect: 'none',
      }}
    >
      збірка: {formattedDate}
    </div>
  );
};

export default BuildInfo;
